import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Spinner/spinner';
import { css } from '@patternfly/react-styles';
export var spinnerSize;
(function (spinnerSize) {
  spinnerSize["sm"] = "sm";
  spinnerSize["md"] = "md";
  spinnerSize["lg"] = "lg";
  spinnerSize["xl"] = "xl";
})(spinnerSize || (spinnerSize = {}));
export var Spinner = function Spinner(_a) {
  var _a$className = _a.className,
    className = _a$className === void 0 ? '' : _a$className,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'xl' : _a$size,
    _a$ariaValuetext = _a['aria-valuetext'],
    ariaValueText = _a$ariaValuetext === void 0 ? 'Loading...' : _a$ariaValuetext,
    _a$isSVG = _a.isSVG,
    isSVG = _a$isSVG === void 0 ? false : _a$isSVG,
    diameter = _a.diameter,
    _a$isInline = _a.isInline,
    isInline = _a$isInline === void 0 ? false : _a$isInline,
    ariaLabel = _a['aria-label'],
    ariaLabelledBy = _a['aria-labelledBy'],
    props = __rest(_a, ["className", "size", 'aria-valuetext', "isSVG", "diameter", "isInline", 'aria-label', 'aria-labelledBy']);
  var Component = isSVG ? 'svg' : 'span';
  return React.createElement(Component, Object.assign({
    className: css(styles.spinner, isInline ? styles.modifiers.inline : styles.modifiers[size], className),
    role: "progressbar",
    "aria-valuetext": ariaValueText
  }, isSVG && {
    viewBox: '0 0 100 100'
  }, diameter && {
    style: {
      '--pf-c-spinner--diameter': diameter
    }
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, ariaLabelledBy && {
    'aria-labelledBy': ariaLabelledBy
  }, !ariaLabel && !ariaLabelledBy && {
    'aria-label': 'Contents'
  }, props), isSVG ? React.createElement("circle", {
    className: styles.spinnerPath,
    cx: "50",
    cy: "50",
    r: "45",
    fill: "none"
  }) : React.createElement(React.Fragment, null, React.createElement("span", {
    className: css(styles.spinnerClipper)
  }), React.createElement("span", {
    className: css(styles.spinnerLeadBall)
  }), React.createElement("span", {
    className: css(styles.spinnerTailBall)
  })));
};
Spinner.displayName = 'Spinner';